var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceolderCategoria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "118px",
    width: "118px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-6.84 -6.84 70.68 70.68",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(0,0), scale(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6.84,
    y: -6.84,
    width: 70.68,
    height: 70.68,
    rx: 0,
    fill: "#2f3131",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.227996
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.784,40.046C56.452,39.4,55.795,39,55.069,39h-1.095c-0.464-12.195-9.362-22.26-21.017-24.52 C32.974,14.319,33,14.159,33,14c0-2.757-2.243-5-5-5s-5,2.243-5,5c0,0.159,0.025,0.32,0.043,0.48 C11.387,16.739,2.489,26.805,2.025,39H1.93c-0.726,0-1.383,0.4-1.715,1.046s-0.276,1.413,0.146,2.004l2.26,3.164 C3.867,46.959,5.891,48,8.034,48h40.932c2.143,0,4.167-1.041,5.413-2.786l2.261-3.164C57.061,41.459,57.116,40.691,56.784,40.046z M25.006,14.172C25.002,14.114,25,14.056,25,14c0-1.654,1.346-3,3-3s3,1.346,3,3c0,0.057-0.002,0.114-0.006,0.172 c-0.047-0.005-0.094-0.007-0.14-0.012c-0.344-0.038-0.69-0.065-1.038-0.089c-0.128-0.009-0.255-0.022-0.383-0.029 C28.957,14.015,28.48,14,28,14s-0.958,0.015-1.432,0.041c-0.128,0.007-0.255,0.02-0.383,0.029 c-0.348,0.024-0.694,0.052-1.038,0.089C25.1,14.165,25.053,14.166,25.006,14.172z M24.406,16.269 c0.535-0.08,1.075-0.138,1.615-0.182c0.11-0.009,0.22-0.017,0.33-0.024c1.098-0.074,2.201-0.074,3.299,0 c0.11,0.008,0.22,0.016,0.33,0.024c0.54,0.044,1.079,0.102,1.615,0.182C42.806,17.96,51.503,27.437,51.979,39H4.02 C4.497,27.437,13.193,17.96,24.406,16.269z M52.751,44.051C51.879,45.271,50.464,46,48.965,46H8.034 c-1.499,0-2.914-0.729-3.786-1.948L2.068,41H54h0.931L52.751,44.051z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.986,18c-1.643,0-3.278,0.181-4.86,0.537c-0.539,0.121-0.877,0.656-0.756,1.195c0.105,0.465,0.518,0.78,0.975,0.78 c0.073,0,0.147-0.008,0.221-0.024C25.004,20.164,26.491,20,27.986,20c0.004,0,0.008,0,0.013,0h0c0.552,0,1-0.447,1-0.999 C29,18.444,28.556,17.981,27.986,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.15,20.899C11.946,23.982,8.158,29.56,7.016,35.82c-0.099,0.544,0.261,1.064,0.805,1.163 C7.881,36.995,7.941,37,8.001,37c0.474,0,0.895-0.338,0.983-0.82c1.039-5.698,4.473-10.768,9.186-13.56 c0.475-0.281,0.632-0.895,0.351-1.37C18.238,20.775,17.626,20.618,17.15,20.899z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceolderCategoria);
export default __webpack_public_path__ + "static/media/placeolder-categoria.7f0fe1feb0858ce6276923d6f4d58d63.svg";
export { ForwardRef as ReactComponent };